<template>
  <v-stage :config="stageConfig">
    <slot></slot>
    <v-layer>
      <v-rect :config="{
        width: chartRenderStore.SCROLLBAR_SIZE,
        height: vScrollBarHeight,
        fill: 'grey',
        opacity: stageHeight >= chartHeight ? 0 : 0.8,
        x: vScrollBarX,
        y: vScrollBarY,
        draggable: true,
        dragBoundFunc: verticalDragBound,
      }" @dragmove="handleVerticalDrag" />
      <v-rect :config="{
        width: hScrollBarWidth,
        height: chartRenderStore.SCROLLBAR_SIZE,
        fill: 'grey',
        opacity: stageWidth >= chartWidth ? 0 : 0.8,
        x: hScrollBarX,
        y: hScrollBarY,
        draggable: true,
        dragBoundFunc: horizontalDragBound,
      }" @dragmove="handleHorizontalDrag" />
      <v-line v-for="(cfg, i) in eventLineConfigs" :config="cfg" :key="i" />
    </v-layer>
  </v-stage>
</template>

<script setup>
import { computed, defineEmits, inject } from 'vue';
import { useChartRenderStore } from '../../stores/ChartRenderStore';

const mainChart = inject('chart')
const { duration } = mainChart
const mainChartRender = inject('chartRender')
const { vScrollBarHeight, hScrollBarWidth, chartPositionY, chartPositionX,
  stageHeight, stageWidth, chartHeight, chartWidth,
  vScrollBarX, vScrollBarY, hScrollBarX, hScrollBarY } = mainChartRender

const emit = defineEmits(['moveX', 'moveY'])

const chartRenderStore = useChartRenderStore()

const eventLineConfigs = computed(() => {
  return mainChart.orderedEventLines.value.map(e => {
    const y = stageHeight.value * (e.time / mainChart.duration.value)
    return {
      points: [
        stageWidth.value - chartRenderStore.SCROLLBAR_PADDING - chartRenderStore.SCROLLBAR_SIZE,
        y,
        stageWidth.value - chartRenderStore.SCROLLBAR_PADDING,
        y],
      stroke: e.colour ?? '#F00',
      strokeWidth: 3
    }
  })
})


const stageConfig = computed(() => ({
  height: stageHeight.value,
  width: stageWidth.value,
  scaleY: chartRenderStore.reverseScroll ? -1 : 1,
  y: chartRenderStore.reverseScroll ? stageHeight.value : 0
}));

const verticalDragBound = (pos) => ({
  x: stageWidth.value - chartRenderStore.SCROLLBAR_PADDING - chartRenderStore.SCROLLBAR_SIZE,
  y: Math.max(
    Math.min(pos.y, stageHeight.value - (chartRenderStore.reverseScroll ? 0 : vScrollBarHeight.value) - chartRenderStore.SCROLLBAR_PADDING),
    chartRenderStore.SCROLLBAR_PADDING + (chartRenderStore.reverseScroll ? vScrollBarHeight.value : 0)
  )
});

const horizontalDragBound = (pos) => ({
  x: Math.max(
    Math.min(pos.x, stageWidth.value - hScrollBarWidth.value - chartRenderStore.SCROLLBAR_PADDING),
    chartRenderStore.SCROLLBAR_PADDING
  ),
  y: chartRenderStore.reverseScroll
    ? chartRenderStore.SCROLLBAR_PADDING + chartRenderStore.SCROLLBAR_SIZE
    : stageHeight.value - chartRenderStore.SCROLLBAR_PADDING - chartRenderStore.SCROLLBAR_SIZE
})

const handleVerticalDrag = (e) => {
  const pos = e.target.position();
  const normalizedValue = (pos.y - chartRenderStore.SCROLLBAR_PADDING) / (stageHeight.value - vScrollBarHeight.value - chartRenderStore.SCROLLBAR_PADDING * 2)
  emit('moveY', normalizedValue * duration.value)
};

const handleHorizontalDrag = (e) => {
  const pos = e.target.position();
  const normalizedValue = (pos.x - chartRenderStore.SCROLLBAR_PADDING) / (stageWidth.value - hScrollBarWidth.value - chartRenderStore.SCROLLBAR_PADDING * 2)
  emit('moveX', normalizedValue)
};

</script>
